<div class="loading-icon {{ slow ? 'loading-icon--slow' : 'loading-icon--fast' }}" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>
